import React from "react";
import {Grid} from "../../UI/Grid";
import { Accordion } from "../../UI/Accordion";
import { AccordionSummary } from "../../UI/AccordionSummary";
import { AccordionDetails } from "../../UI/AccordionDetails";
import {useUserContext} from "../../contexts/UserContext";
import {LeaveRoommateGroupButton} from "../LeaveRoommateGroupButton";
import {MatchWithAnotherUserButton} from "../MatchWithAnotherUserButton";
import {CopyRoommatesButton} from "../CopyRoommatesButton";
import {RoommatesTable} from "../RoommatesTable";
import {RoommateType} from "../RoommatesTable/RoommatesTable";

export const MatchingActivity = () => {
  const [isAccordionExpanded, setAccordionExpanded] = React.useState(false);
  const { user } = useUserContext();
  return (
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          <RoommatesTable roommateType={RoommateType.CURRENT}/>
        </Grid>

        <Grid container spacing={2} mt={1} pl={2}>
          {!!user?.roommates.length && (
              <Grid item>
                <LeaveRoommateGroupButton/>
              </Grid>
          )}

          <Grid item>
            <MatchWithAnotherUserButton/>
          </Grid>

          <Grid item>
            <CopyRoommatesButton/>
          </Grid>

        </Grid>

        <Grid item>
            
        </Grid>
        <Grid item xs={12} spacing={0} px={0}>
        <Accordion expanded={isAccordionExpanded} onChange={() =>{setAccordionExpanded(!isAccordionExpanded);}}>
          <AccordionSummary>
            {isAccordionExpanded ? "Hide Past Roommates" : "See Past Roommates"}
          </AccordionSummary>
          <AccordionDetails>
            <RoommatesTable roommateType={RoommateType.PAST}/>
          </AccordionDetails>
          
        </Accordion>
        </Grid>


      </Grid>
  );
};
